var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCastForEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 73,
    viewBox: "0 0 89 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0945 0.283936H8.09448C3.69448 0.283936 0.0944824 3.88394 0.0944824 8.28394V20.2839H8.09448V8.28394H80.0945V64.2839H52.0945V72.2839H80.0945C84.4945 72.2839 88.0945 68.6839 88.0945 64.2839V8.28394C88.0945 3.88394 84.4945 0.283936 80.0945 0.283936ZM0.0944824 60.2839V72.2839H12.0945C12.0945 65.6439 6.73448 60.2839 0.0944824 60.2839ZM0.0944824 44.2839V52.2839C11.1345 52.2839 20.0945 61.2439 20.0945 72.2839H28.0945C28.0945 56.8039 15.5745 44.2839 0.0944824 44.2839ZM0.0944824 28.2839V36.2839C19.9745 36.2839 36.0945 52.4039 36.0945 72.2839H44.0945C44.0945 47.9639 24.3745 28.2839 0.0944824 28.2839ZM40.0945 32.6439V40.6439L54.0945 48.2839L68.0945 40.6439V32.6439L54.0945 40.2839L40.0945 32.6439ZM54.0945 12.2839L32.0945 24.2839L54.0945 36.2839L76.0945 24.2839L54.0945 12.2839Z",
    fill: "url(#paint0_linear_1_93)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_93",
    x1: 44.0945,
    y1: 0.283936,
    x2: 44.0945,
    y2: 72.2839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0D2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastForEducation);
export default __webpack_public_path__ + "static/media/cast_for_education.49f03bbfa4f4535e5c81ed3b88a1242c.svg";
export { ForwardRef as ReactComponent };